/**
 * Hotjar Adapter
 * 
 * Hotjar is primarily used for heatmaps, recordings, and user feedback.
 * It doesn't track traditional ecommerce events, only pixel load.
 * 
 * This adapter is included for consistency but returns null for all events
 * since Hotjar doesn't use event-based tracking in the same way as other pixels.
 * 
 * @since 1.51.0
 */

(function (pmw, $, undefined) {

	class HotjarAdapter {
		
		/**
		 * Adapt event data to Hotjar format
		 * 
		 * Hotjar doesn't track traditional ecommerce events, so this always returns null.
		 * The pixel is loaded via the pmw:load-pixels event, not through event-specific triggers.
		 * 
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {null} Always null - Hotjar doesn't use event tracking
		 */
		adapt(eventData, eventName, context) {
			// Hotjar doesn't track ecommerce events
			// It only loads the tracking script for session recordings and heatmaps
			return null;
		}
	}
	
	// Register the adapter
	pmw.registerAdapter('hotjar', new HotjarAdapter(), {
		supportsS2S: false,
		supportsEventDeduplication: false,
		isActive: () => pmwDataLayer?.pixels?.hotjar?.site_id ? true : false
	});
	
}(window.pmw = window.pmw || {}, jQuery));
